import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";
import HeaderEn from "../../header-en";
import FooterEn from "../../footer-en";

function AccountVerifyEn(props) {
  const [sendMessage, setSendMessage] = useState(
    "Hello,I'mInVerificationPageEn"
  );
  const [userCodeDigit1, setUserCodeDigit1] = useState("");
  const [userCodeDigit2, setUserCodeDigit2] = useState("");
  const [userCodeDigit3, setUserCodeDigit3] = useState("");
  const [userCodeDigit4, setUserCodeDigit4] = useState("");
  const [userCodeDigit5, setUserCodeDigit5] = useState("");
  const [verifyError, setVerifyError] = useState(false);
  const [messageError, setMessageError] = useState("");

  useEffect(() => {
    handleRedirect();
    sendVerificationEmail();
  }, []);

  const handleRedirect = async () => {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: sendMessage,
    });
    return true;
  };

  const sendVerificationEmail = async () => {
    console.log("token is:", localStorage.getItem("token"));
    const response = await axios.post(
      "https://request.kidiar.com/register/sendmail",
      { something: null },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    console.log("verification response:", response);
    return true;
  };

  const submitHandler = async () => {
    if (
      userCodeDigit1 === "" ||
      userCodeDigit2 === "" ||
      userCodeDigit3 === "" ||
      userCodeDigit4 === "" ||
      userCodeDigit5 === ""
    ) {
      setVerifyError(true);
      setMessageError("Please fill all the fields");
      return;
    }
    console.log("Token is", localStorage.getItem("token"));
    const userCode =
      userCodeDigit1 +
      userCodeDigit2 +
      userCodeDigit3 +
      userCodeDigit4 +
      userCodeDigit5;
    const response = await axios.post(
      "https://request.kidiar.com/register/verify",
      { usercode: userCode },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    console.log(response.data);

    if (response.data.auth == true) {
      window.location.href = "/en/panel";
    } else {
      setVerifyError(true);
      setMessageError("The code is not correct");
    }
  };

  return (
    <div className="container-v1">
      <HeaderEn />
      <div className="signup">
        <div className="signup-container">
          <div className="form-wrapper d-ltr">
            <h1 className="align-text-center">{"Verify your email address"}</h1>
            <p className="align-text-center" style={{ whiteSpace: "pre-line" }}>
              {
                "We emailed you a 4-digit code. Enter the code below to confirm the email address. \nAlso check the spam folder if needed!"
              }
            </p>
            <div className="d-flex mt-1 mb-1 justify-content-center">
              <input
                value={userCodeDigit1}
                style={{ width: "1em", fontSize: "1.5em", textAlign: "center" }}
                onClick={(e) => setUserCodeDigit1("")}
                onChange={(e) => {
                  if (
                    e.target.value === "" ||
                    e.target.value === "0" ||
                    e.target.value === "1" ||
                    e.target.value === "2" ||
                    e.target.value === "3" ||
                    e.target.value === "4" ||
                    e.target.value === "5" ||
                    e.target.value === "6" ||
                    e.target.value === "7" ||
                    e.target.value === "8" ||
                    e.target.value === "9"
                  ) {
                    setUserCodeDigit1(e.target.value);
                    if (e.target.value !== "")
                      document.getElementById("digit2").focus();
                  }
                }}
              ></input>
              <input
                id="digit2"
                value={userCodeDigit2}
                style={{ width: "1em", fontSize: "1.5em", textAlign: "center" }}
                onClick={(e) => setUserCodeDigit2("")}
                onChange={(e) => {
                  if (
                    e.target.value === "" ||
                    e.target.value === "0" ||
                    e.target.value === "1" ||
                    e.target.value === "2" ||
                    e.target.value === "3" ||
                    e.target.value === "4" ||
                    e.target.value === "5" ||
                    e.target.value === "6" ||
                    e.target.value === "7" ||
                    e.target.value === "8" ||
                    e.target.value === "9"
                  ) {
                    setUserCodeDigit2(e.target.value);
                    if (e.target.value !== "")
                      document.getElementById("digit3").focus();
                  }
                }}
              ></input>
              <input
                id="digit3"
                value={userCodeDigit3}
                style={{ width: "1em", fontSize: "1.5em", textAlign: "center" }}
                onClick={(e) => setUserCodeDigit3("")}
                onChange={(e) => {
                  if (
                    e.target.value === "" ||
                    e.target.value === "0" ||
                    e.target.value === "1" ||
                    e.target.value === "2" ||
                    e.target.value === "3" ||
                    e.target.value === "4" ||
                    e.target.value === "5" ||
                    e.target.value === "6" ||
                    e.target.value === "7" ||
                    e.target.value === "8" ||
                    e.target.value === "9"
                  ) {
                    setUserCodeDigit3(e.target.value);
                    if (e.target.value !== "")
                      document.getElementById("digit4").focus();
                  }
                }}
              ></input>
              <input
                id="digit4"
                value={userCodeDigit4}
                style={{ width: "1em", fontSize: "1.5em", textAlign: "center" }}
                onClick={(e) => setUserCodeDigit4("")}
                onChange={(e) => {
                  if (
                    e.target.value === "" ||
                    e.target.value === "0" ||
                    e.target.value === "1" ||
                    e.target.value === "2" ||
                    e.target.value === "3" ||
                    e.target.value === "4" ||
                    e.target.value === "5" ||
                    e.target.value === "6" ||
                    e.target.value === "7" ||
                    e.target.value === "8" ||
                    e.target.value === "9"
                  ) {
                    setUserCodeDigit4(e.target.value);
                    if (e.target.value !== "")
                      document.getElementById("digit5").focus();
                  }
                }}
              ></input>
              <input
                id="digit5"
                value={userCodeDigit5}
                style={{ width: "1em", fontSize: "1.5em", textAlign: "center" }}
                onClick={(e) => setUserCodeDigit5("")}
                onChange={(e) => {
                  if (
                    e.target.value === "" ||
                    e.target.value === "0" ||
                    e.target.value === "1" ||
                    e.target.value === "2" ||
                    e.target.value === "3" ||
                    e.target.value === "4" ||
                    e.target.value === "5" ||
                    e.target.value === "6" ||
                    e.target.value === "7" ||
                    e.target.value === "8" ||
                    e.target.value === "9"
                  ) {
                    setUserCodeDigit5(e.target.value);
                  }
                }}
              ></input>
            </div>
            <div className="d-flex flex-column mt-4 align-items-center">
              <a
                className="sbt-btn d-flex flex-column"
                onClick={() => submitHandler()}
              >
                <p>{"تایید"}</p>
              </a>
              <div className="d-flex flex-column">
                <p style={{ whiteSpace: "pre-line" }}>
                  {"Didn't receive the code?"}
                  {"\nClick "}
                  <a className="mode-text-14">{"here"}</a>
                  {" to send again"}
                </p>
              </div>
            </div>
            {verifyError && (
              <div className="mode-text-11 font-12">{messageError}</div>
            )}
          </div>
        </div>
      </div>
      <FooterEn />
    </div>
  );
}

export default AccountVerifyEn;
